import React, { useContext, useEffect } from 'react';
import { NavLink, useHistory, useParams } from 'react-router-dom';
import {
  Footer,
  Layout,
  MobileTabBar,
  Notification,
} from '../../../components';

import '../profile-general.less';
import './history.less';

import { Table, Tabs } from 'antd';

import RightChevronIcon from '../../../assests/icons/right-chevron.icon';
import { DimensionsContext } from '../../../context/dimensions.context';
import ProfileMenu from '../profilemenu';

const { TabPane } = Tabs;

const Profile = () => {
  const { isTabletBig, isScreenLG } = useContext(DimensionsContext);
  let { status } = useParams();

  const columns = [
    {
      title: 'İşlem',
      dataIndex: 'requestTitle',
    },
    {
      title: 'İşlem Tarihi',
      dataIndex: 'date',
    },
  ];
  const data = [
    {
      key: '1',
      requestTitle: 'TURKCELL',
      date: '02.02.2020 - 13:45',
    },
    {
      key: '2',
      requestTitle: 'TURKCELL',
      date: '02.02.2020 - 13:45',
    },
    {
      key: '3',
      requestTitle: 'TURKCELL',
      date: '02.02.2020 - 13:45',
    },
    {
      key: '4',
      requestTitle: 'TURKCELL',
      date: '02.02.2020 - 13:45',
    },
    {
      key: '5',
      requestTitle: 'TURKCELL',
      date: '02.02.2020 - 13:45',
    },
    {
      key: '6',
      requestTitle: 'TURKCELL',
      date: '02.02.2020 - 13:45',
    },
  ];

  let history = useHistory();

  function onChangeTabs(key) {
    if (key == 1) {
      history.push('./Profile');
    } else if (key == 2) {
      history.push('./Permission');
    } else if (key == 3) {
      history.push('./Title');
    } else if (key == 4) {
      history.push('./History');
    }
  }

  useEffect(() => {
    if (status === 'success') {
      Notification(
        'bottomLeft',
        'Tcell',
        'notification--v2',
        'için ünvan başvurunuz başarıyla sonuçlandı',
        'success'
      );
    }
  }, [status]);

  return (
    <Layout>
      <div className="profile-page profile-page--history">
        <div className="container">
          <div className="profile-page__title">
            <h1 className="section__title">Profilim</h1>
          </div>
          <div className="content-wrapper">
          <ProfileMenu></ProfileMenu>
            <div className="profile-page__content">
              <h2 className="box__title">İşlemlerim</h2>
              <div className="table-wrapper">
                <Table
                  columns={columns}
                  scroll={{ y: 610 }}
                  dataSource={data}
                  className="table--guide"
                  pagination={{ total: 100, position: ['bottomCenter'] }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default Profile;
